<a [routerLink]="href" class="alert-action">
  <ng-content></ng-content>
  <span class="alert-action__icon"><mat-icon>chevron_right</mat-icon></span>
</a>
